import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const { t } = useTranslation();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-900 hover:text-primary-500 transition-colors"
          >
            <span className="text-xl font-heading font-bold whitespace-nowrap">
              {t('site.name')}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/')
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              {t('nav.home')}
            </Link>
            <Link
              to="/category/mystery"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname.startsWith('/category')
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              {t('nav.category')}
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/about')
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              {t('nav.about')}
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link
              to="/"
              className={`text-sm font-medium py-2 whitespace-nowrap ${
                isActive('/') ? 'text-primary-500' : 'text-foreground-700'
              }`}
            >
              {t('nav.home')}
            </Link>
            <Link
              to="/category/mystery"
              className={`text-sm font-medium py-2 whitespace-nowrap ${
                location.pathname.startsWith('/category')
                  ? 'text-primary-500'
                  : 'text-foreground-700'
              }`}
            >
              {t('nav.category')}
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium py-2 whitespace-nowrap ${
                isActive('/about') ? 'text-primary-500' : 'text-foreground-700'
              }`}
            >
              {t('nav.about')}
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}